import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-template-article',
  templateUrl: './template-article.component.html',
  styleUrls: ['./template-article.component.scss']
})
export class TemplateArticleComponent implements OnInit {

    @Input() title: string;
    @Input() pathImg: string;
    @Input() content: string;
    @Input() date: Date;

    constructor() { }

    ngOnInit(): void {
    }

}
